import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const showSuccessToast = (msg: string) => {
	toast.success(msg, {
		position: "top-right",
		autoClose: 5000,
		closeOnClick: true,
		hideProgressBar: true,
		style: { backgroundColor: "lightgreen" , color: "black"}
	});
};

export const showInfoToast = (msg: string) => {
	toast.info(msg, {
		position: "top-right",
		autoClose: 5000,
		closeOnClick: true,
		hideProgressBar: true,
	});
};

export const showErrorToast = (msg: string) => {
	toast.error(msg, {
		position: "top-right",
		autoClose: 5000,
		closeOnClick: true,
		hideProgressBar: true,
	});
};

export const showWarningToast = (msg: string) => {
	toast.warning(msg, {
		position: "top-right",
		autoClose: 5000,
		closeOnClick: true,
		hideProgressBar: true,
	});
};
